import { type ReactElement } from "react";
import { createRoot, type Root } from "react-dom/client";

import type {
  ICellRendererComp,
  IDetailCellRendererParams
} from "ag-grid-enterprise";

export class DetailCellRenderer implements ICellRendererComp {
  private eGui!: HTMLElement;
  private root: Root | undefined;

  init(params: IDetailCellRendererParams<{ subComponent: ReactElement }>) {
    this.eGui = document.createElement("section");

    const data = params.data;
    const CustomSubComponent = data?.subComponent;

    // Mount the React Root and render JSX
    this.root = createRoot(this.eGui);
    this.root.render(CustomSubComponent);
  }

  getGui(): HTMLElement {
    return this.eGui;
  }

  refresh(): boolean {
    return false;
  }

  destroy() {
    // Clean up React root when row collapses/destroys
    if (this.root) {
      const rootToUnmount = this.root;
      this.root = undefined; // Prevent duplicate calls

      // Defer unmounting to avoid the race condition
      setTimeout(() => {
        rootToUnmount.unmount();
      }, 0);
    }
  }
}
